import React,{ Component } from 'react';
import { Row, Col, ButtonGroup, Button, Alert } from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import countriesObj from "../../../../data/countries";
import { handleFieldChange } from "../../../../Utils";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Filters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      alert: null,
      day: '',
      country: null
    };

    this.handleFieldChange = handleFieldChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleFormSubmit(type) {
    const isValid = this.validateForm();
    const filters = Object.assign({}, this.state);

    if(isValid) this.props.onSubmit(filters, type);
  }

  validateForm() {
    const { day } = this.state;

    let alert = null;

    if(!day) alert = 'Please set Date';

    this.setState({ alert });

    return !alert;
  }

  getAlert() {
    const { alert } = this.state;

    if(alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
  }

  render() {
    return (
      <form>
        {this.getAlert()}
        <Row>
          <Col lg={4}>
            <FieldGroup
              type="date"
              name="day"
              label="Date:"
              onChange={this.handleFieldChange}
              value={this.state.date}
            />
          </Col>
          <Col lg={8}>
            <SelectWrap
              values={countriesOptions}
              label="Countries:"
              name="country"
              onChange={this.handleFieldChange}
              value={this.state.country}
              multi
            />
          </Col>
        </Row>

        <ButtonGroup>
          <Button type="button" bsStyle="info" className="m-b-15" onClick={() => this.handleFormSubmit()}>Load</Button>
        </ButtonGroup>
      </form>
    );
  }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/AdkPartnerGraph/components/Form/index.js